import React, { useState } from 'react';
import AuthContext from './AuthContext';
import authService from '../../services/auth/authService';

const AuthState = (props) => {
  const [authLoading, setAuthLoading] = useState(false);

  const login = async (credentials) => {
    return await authService.login(credentials);
  };

  const sendEmailOtp = async (payload) => {
    return await authService.sendEmailOtp(payload);
  };

  const sendSmsOtp = async (payload) => {
    return await authService.sendSmsOtp(payload);
  };

  const verifyEmailOtp = async (payload) => {
    return await authService.verifyEmailOtp(payload);
  };

  const verifySmsOtp = async (payload) => {
    return await authService.verifySmsOtp(payload);
  };

  const resetPassword = async (payload) => {
    return await authService.resetPassword(payload);
  };

  const sendSignupSmsOtp = async (payload) => {
    return await authService.sendSignupSmsOtp(payload);
  };

  const verifySignupPhoneOtp = async (payload) => {
    return await authService.verifySignupPhoneOtp(payload);
  };

  const uploadLogo = async (file) => {
    return await authService.uploadLogo(file);
  };

  const registerAgent = async (agentData) => {
    return await authService.registerAgent(agentData);
  };

  return (
    <AuthContext.Provider
      value={{
        authLoading,
        setAuthLoading,
        login,
        sendEmailOtp,
        sendSmsOtp,
        verifyEmailOtp,
        verifySmsOtp,
        resetPassword,
        sendSignupSmsOtp,
        verifySignupPhoneOtp,
        uploadLogo,
        registerAgent
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
